export class FinishResetPasswordRequest {
    resetKey: string = "";
    newPassword: string = "";
}